/**
 * Created by mqamhieh on 11/23/16.
 */
window.VerifiedLocationForm = function (scope, userLocation, googleSearchService, hUser, googleMaps) {
    var self = this;
    var formName = "verified-location-form";
    var _protected = BaseForm.call(self, formName, scope);
    let locations = [];

    const forceUpdate = !hUser.isLoggedIn();

    const getUserPrimaryResidence = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const userLocation = await hUser.getUserLocation();
                const result = await googleMaps.locationAutocomplete(userLocation.lat + "," + userLocation.lon);

                resolve(result?.[0]);
            } catch (e) {
                console.log(e);
                reject(e);
            }
        });

    };

    if (userLocation) {
        self.data.primaryLocation = {
            value: userLocation,
            label: userLocation.formatted_address,
            id: userLocation.id
        };
    }

    getUserPrimaryResidence()
        .then((response) => {
            self.data.primaryResidence = {
                value: response?.value,
                label: response?.label,
                id: response?.value?.result?.place_id,
            };
        })
        .catch((e) => {
            console.error(e);
        });

    let getLocations = async (searchTerm) => {
        try {
            const locationsList = await googleSearchService.getAddress(searchTerm);
            return locationsList.map(location => {
                return {
                    ...location,
                    id: location.value.result.place_id
                };
            });
        } catch (err) {
            console.error(err);
            throw err;
        }
    }

    self.onLocationChanged = (items) => {
        if (items) {
            self.data.primaryLocation = items[0];
        }
    };

    self.getLocationsBySearchQuery = async ($event) => {
        const defer = $q.defer();
        if ($event.value?.length > 2) {
            const searchTerm = $event.value;
            try {
                locations = await getLocations(searchTerm);
                defer.resolve(locations);
            } catch (err) {
                console.error(err);
                defer.reject(err);
            }
         } else if (userLocation) {
            try {
                locations = await getLocations(userLocation?.formatted_address);
                self.data.primaryLocation = locations[0];
                defer.resolve(locations);
            } catch (err) {
                console.error(err);
                defer.reject(err);
            }
        } else {
            defer.resolve([]);
         }
        return defer.promise;
    };


    self.load = function () {
        var defer = $q.defer();

        // Load the location from the API when the form is rendered and before active
        TimeGeographyAPI.load()
            .then(function (data) {
                var primaryLocation = TimeGeographyAPI.findPrimaryLocation(data);

                if (primaryLocation) {
                    self.data.primaryLocation = {
                        value: primaryLocation,
                        label: primaryLocation.formatted_address
                    };
                }

                defer.resolve();
            },
            function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.save = function () {
        var defer = $q.defer();

        var payload = { 'user_location': [] };

        if (self.data.useCurrentLocation) {
            payload.user_location.push({
                google_location: self.data.primaryResidence.value,
                is_primary: true
            });
        }
        else if (self.data.primaryLocation?.value?.id) {
            // Location was not changed by user
            payload.user_location.push({
                location_id: self.data.primaryLocation.value.id,
                is_primary: true
            });
        }
        else if (self.data.primaryLocation?.value?.result) {
            // Location from Google
            payload.user_location.push({
                google_location: self.data.primaryLocation.value,
                is_primary: true
            });
        }
        else {
            defer.reject({ error: "Couldn't save primary location"});
        }

        if (payload['user_location'][0]) {
            payload.force = forceUpdate;
            TimeGeographyAPI.save(payload)
                .then(function (res) {
                    defer.resolve(res);
                },
                function (err) {
                    defer.reject(err);
                });
        }

        return defer.promise;
    };
};